import React from "react";
import MainLayout from "../../../components/Layouts";
import ShopProductDetails from "../../../components/Shop/Product/details";

const ShopProductDetailsPage = () => {
  return (
  
<h1>okkkkkk</h1>

  );
};

export default ShopProductDetailsPage;
